"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.getNameByPixels = exports.getBreakpointByName = exports.getBreakpoints = void 0;

var _lodash = _interopRequireDefault(require("lodash"));

var _breakpoints = _interopRequireDefault(require("../sass/utils/_breakpoints.scss"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var getBreakpoints = function getBreakpoints() {
  return _breakpoints.default;
};

exports.getBreakpoints = getBreakpoints;

var getBreakpointByName = function getBreakpointByName(name) {
  var breakAt = _lodash.default.get(_breakpoints.default, name, 0);

  return parseInt(breakAt, 10);
};

exports.getBreakpointByName = getBreakpointByName;

var getNameByPixels = function getNameByPixels(pixelSize) {
  var currentBreakpointName; // iterate through each of the breakpoints

  _lodash.default.forIn(_breakpoints.default, function (startsAt, breakPointName) {
    // check if current size is greater than min
    if (startsAt === 0 || pixelSize >= startsAt) {
      // if the current size is greater than the min (or 0 to catch mobile)
      currentBreakpointName = breakPointName;
    }
  });

  return currentBreakpointName;
};

exports.getNameByPixels = getNameByPixels;
var _default = {
  getBreakpoints: getBreakpoints,
  getBreakpointByName: getBreakpointByName,
  getNameByPixels: getNameByPixels
};
exports.default = _default;